import React from 'react';
import angryManSvg from '../../assets/icons/angry-man-svgrepo-com.svg';

interface AngryManIconProps {
  size?: number;
  className?: string;
}

const AngryManIcon: React.FC<AngryManIconProps> = ({ size = 48, className = '' }) => {
  return (
    <img 
      src={angryManSvg} 
      alt="Angry Man Icon"
      width={size}
      height={size}
      className={className}
    />
  );
};

export default AngryManIcon;
